export default "__VITE_ASSET__BcIdXb86__"